import React, { FC } from 'react';
import { CustomButton } from '@mindly/ui-components';
import { ISubscription } from '../../../../redux/subscriptions/types';
import { IonIcon } from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';
import { SubscriptionActionModalText, SubscriptionActionModalTitle } from '../CancelSubscriptionModal.style';
import useLangs from '../../../../context/LangsContext';
import { FormattedMessage } from 'react-intl';

type FinishStepProps = {
  handleClose: () => void;
  subscription?: ISubscription | null;
};

const FinishStep: FC<FinishStepProps> = ({ handleClose, subscription }) => {
  const { locale } = useLangs();

  if (!subscription) return null;

  return (
    <div className={'finish-step-wrapper'}>
      <IonIcon icon={checkmarkCircleOutline} />
      <SubscriptionActionModalTitle>
        <FormattedMessage id={'subscription.cancel.step.4.title'} defaultMessage={'Вашу підписку скасовано'} />
      </SubscriptionActionModalTitle>
      <SubscriptionActionModalText className={'cancel-text'}>
        <FormattedMessage
          id={'subscription.cancel.step.4.test'}
          defaultMessage={'Ви ще можете записуватися на сеанси доки Ваш поточний план не закінчиться'}
        />{' '}
        <b>
          {new Date(+subscription?.period_end * 1000).toLocaleString(locale, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </b>
      </SubscriptionActionModalText>
      <CustomButton buttonType={'primary'} onClick={handleClose}>
        <FormattedMessage id={'general.good.btn'} defaultMessage={'Добре'} />
      </CustomButton>
    </div>
  );
};

export default FinishStep;
